import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  SimpleGrid,
  Box,
  Input,
  FormLabel,
  Select,
  InputGroup,
  InputLeftAddon,
  useDisclosure,
  Checkbox,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import axios from "axios";
import toast from "react-hot-toast";
import Cookie from "js-cookie";

const RoomBillEdittModal = ({
  isOpen,
  onClose,
  id,
  customerId,
  onOpen,
  setSelectId,
  data,
}) => {
  const token = Cookie.get("token");

  // console.log(id,'id')
  const [selectedFile, setSelectedFile] = useState(null);
  const [roomdata, setData] = useState([]);
  const [newImageURL, setnewImageURL] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [printData, setPrintData] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    registration: "",
    billNo: "",
    date: "",
    address: "",
    phoneNo: "",
    gstNo: "",
    checkIn: "",
    checkInTime: "",
    checkOut: "",
    checkOutTime: "",
    roomSelect: "",
    roomNo: "",

    rate: 0,
    sgst: 0,
    cgst: 0,
    total: 0,
    discount: 0,
  });

  //  console.log(unique,'unique')
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getRoomdata/${customerId}`,
      );
      const rooms = response.data.room;

      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            try {
              const imageResponse = await axios.get(
                `https://api.hotel.launchlysoftware.in/get-image/${room.image}`,
                { responseType: "blob" },
              );
              room.imageUrl = URL.createObjectURL(imageResponse.data);
            } catch (error) {
              console.error(
                `Error fetching image for room: ${room.image}`,
                error,
              );
              room.imageUrl = null;
            }
          } else {
            room.imageUrl = null;
          }
          return room;
        }),
      );

      setData(updatedRooms);
    } catch (error) {
      console.error("Error fetching room data:", error);
      toast.error("Failed to load room data.");
    }
  };

  // console.log(Object.keys(data)+" :"+Object.values(data),'data')

  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || "",
        billNo: data.billNo || "",
        registration: data.registration || "",
        date: data.date || "",
        address: data.address || "",
        phoneNo: data.phoneNo || "",
        gstNo: data.gstNo || "",
        checkIn: data.checkIn || "",
        checkInTime: data.checkInTime || "",
        checkOut: data.checkOut || "",
        checkOutTime: data.checkOutTime || "",
        roomSelect: data.roomSelect || "",
        roomNo: data.roomNo || "",
        rate: data.rate ? parseInt(data.rate) : 0, // Set rate as data.rate only
        sgst: data.sgst || 0,
        cgst: data.cgst || 0,
        total: data.total || 0,
        discount: data.discount || 0,
      });
    }
  }, [data]);

  const change = (e) => {
    e.preventDefault();
    setFormData((prev) => ({
      ...prev,
      rate: data.rate ? parseInt(data.rate) - parseInt(prev.discount || 0) : 0,
    }));
  };
  const formatTimeToAMPM = (time) => {
    const formattedTime = new Date(`6000-01-01T${time}`);
    return formattedTime.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  useEffect(() => {
    fetchData();
  }, [data]);
  const filter = roomdata.filter((item) => item.roomNo === data.roomNo);
  console.log(filter, "filter");

  const scroll = "inside";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  const fetchData3 = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getPrintData/${customerId}`,
      );
      const rooms = response.data;

      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(
              `https://api.hotel.launchlysoftware.in/get-image/${room.image}`,
              {
                responseType: "blob", // Assuming image is returned as a blob
              },
            );

            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        }),
      );

      console.log(updatedRooms, "updatedRooms");
      setPrintData(updatedRooms);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  let room = printData.map((item) => item.roomType);
  const roomTypes = room[0]?.split(",")?.map((item) => item.trim());

  //  console.log(newImageURL,'newImageURL')
  let roomRate = 0;
  let roomCgst = 0;
  let roomSgst = 0;
  let roomTotal = 0;
  let roomNo = data?.roomNo;
  let roomArray = roomNo?.split(",").map((room) => room.trim());
  if (data.roomNo) {
    for (let rooms of roomArray) {
      let selected = roomdata.find((item) => item.roomNo === rooms);
      if (selected) {
        roomRate = roomRate + selected.rate;
        roomCgst = roomCgst + selected.cgst;
        roomSgst = roomSgst + selected.sgst;
      }
    }
  }

  const time = printData[0]?.checkoutTime;
  console.log(typeof printData[0], "time");
  function calculateNumberOfDays(
    checkIn,
    checkOut,
    checkOutTime,
    thresholdTime,
  ) {
    const checkInDate = new Date(checkIn);
    const checkOutDate = new Date(checkOut);

    // Calculate the difference in days
    let numberOfDays = Math.ceil(
      (checkOutDate - checkInDate) / (1000 * 60 * 60 * 24),
    );

    // Parse checkOutTime
    const parseTime = (time) => {
      const [timePart, meridian] = time.split(" ");
      let [hours, minutes] = timePart.split(":").map(Number);
      if (meridian === "PM" && hours !== 12) {
        hours += 12;
      }
      if (meridian === "AM" && hours === 12) {
        hours = 0;
      }
      return { hours, minutes };
    };

    const checkOutParsed = parseTime(checkOutTime);
    const thresholdParsed = parseTime(thresholdTime);

    // Compare checkOutTime with thresholdTime
    const checkOutExceedsThreshold =
      checkOutParsed.hours > thresholdParsed.hours ||
      (checkOutParsed.hours === thresholdParsed.hours &&
        checkOutParsed.minutes > thresholdParsed.minutes);

    // Add an extra day if checkOutTime exceeds the threshold
    if (checkOutExceedsThreshold) {
      numberOfDays += 1;
    }

    return numberOfDays;
  }
  const generateGst = () => {
    const numberOfDays = calculateNumberOfDays(
      formData.checkIn,
      formData.checkOut,
      formData.checkOutTime,
      time,
    );
    roomTotal =
      numberOfDays *
      (parseInt(formData.rate) +
        parseInt(formData.rate * 0.025) +
        parseInt(formData.rate * 0.025));
    setFormData((prev) => ({
      ...prev,
      rate: parseInt(formData.rate) * numberOfDays,
      sgst: parseInt(formData.rate * 0.025) * numberOfDays,
      cgst: parseInt(formData.rate * 0.025) * numberOfDays,
      checkInTime: formatTimeToAMPM(formData.checkInTime),
      checkOutTime: formatTimeToAMPM(formData.checkOutTime),
      total: roomTotal,
    }));
  };
  const handleSubmit = (e) => {};
  useEffect(() => {
    fetchData3();
  }, [data]);
  const handleEdit = async (e) => {
    e.preventDefault();
    const updatedFormData = { ...formData };

    try {
      const response = await axios.put(
        `https://api.hotel.launchlysoftware.in/api/updateRoomBill/${customerId}/${id}?customerId=${customerId}`,
        updatedFormData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }, // Send data directly
      );

      toast.success(response.data.message);
      console.log(response, "response");

      // Optionally reset the form after a successful update
      setFormData({
        name: "",
        registration: "",
        date: "",
        billNo: "",
        address: "",
        phoneNo: "",
        gstNo: 0,
        checkIn: "",
        checkInTime: "",
        checkOut: "",
        checkOutTime: "",
        roomSelect: "",
        roomNo: "",

        rate: 0,
        sgst: 0,
        cgst: 0,
        total: 0,
      });
      window.location.reload();
    } catch (error) {
      toast.error(error.response.data.message);
      console.error("Update failed:", error);
    }
  };

  const handleClick = () => {
    onClose();
    setSelectId(null);
  };
  return (
    <Modal
      width="full"
      size="3xl"
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      scrollBehavior={scroll}
    >
      <ModalOverlay />
      <ModalContent bg="#f9f1e3">
        <ModalHeader
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text>Room Bill Data- {data?.name}</Text>
          <Button colorScheme="red" onClick={handleClick}>
            <IoMdClose />
          </Button>
        </ModalHeader>

        <ModalBody>
          <SimpleGrid columns={2} gap={4} placeItems="left">
            <InputGroup>
              <InputLeftAddon>Name</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="name"
                placeholder="Enter Name"
                value={formData.name}
                readOnly
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Registration</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="registration"
                placeholder="Enter Registration"
                value={formData.registration}
                readOnly
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Bill No</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="billNo"
                placeholder="Enter Bill No"
                value={formData.billNo}
                readOnly
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Date</InputLeftAddon>
              <Input
                type="date"
                w="70%"
                bg="#FAFAFA "
                placeholder="Enter Date"
                name="date"
                value={formData.date}
                onChange={handleInputChange}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Address</InputLeftAddon>
              <Input
                width="70%"
                bg="white"
                onChange={handleInputChange}
                name="address"
                placeholder="Enter Type"
                value={formData.address}
                readOnly
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Phone No</InputLeftAddon>
              <Input
                w="70%"
                bg="#FAFAFA "
                placeholder="Enter Phone"
                name="phoneNo"
                value={formData.phoneNo}
                onChange={handleInputChange}
                readOnly
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>GstNo</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="gstNo"
                placeholder="Enter GstNo"
                value={formData.gstNo}
              />
            </InputGroup>

            <InputGroup>
              {" "}
              <InputLeftAddon>CheckIn</InputLeftAddon>
              <Input
                type="date"
                bg="white"
                onChange={handleInputChange}
                name="checkIn"
                placeholder="Enter CheckIn"
                value={formData.checkIn}
                readOnly
              />
            </InputGroup>
            <InputGroup>
              {" "}
              <InputLeftAddon>CheckIn Time</InputLeftAddon>
              <Input
                type="time"
                bg="white"
                onChange={handleInputChange}
                name="checkInTime"
                placeholder="Enter CheckInTime"
                value={formData.checkInTime}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>CheckOut</InputLeftAddon>
              <Input
                type="date"
                width="68%"
                bg="white"
                onChange={handleInputChange}
                name="checkOut"
                placeholder="Enter CheckOut"
                value={formData.checkOut}
                readOnly
              />
            </InputGroup>
            <InputGroup>
              {" "}
              <InputLeftAddon>CheckOut Time</InputLeftAddon>
              <Input
                type="time"
                bg="white"
                onChange={handleInputChange}
                name="checkOutTime"
                placeholder="Enter CheckOutTime"
                value={formData.checkOutTime}
              />
            </InputGroup>
            {/* <InputGroup> <InputLeftAddon>Room Select</InputLeftAddon>
           <Input   bg='white' onChange={handleInputChange} name='roomSelect' placeholder='Enter Room' value={formData.roomSelect} />
           </InputGroup>  */}
            <InputGroup>
              {" "}
              <InputLeftAddon>Room No</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="roomNo"
                readOnly
                placeholder="Enter Room"
                value={formData.roomNo}
              />
            </InputGroup>
            <InputGroup>
              {" "}
              <InputLeftAddon>Rate</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="rate"
                placeholder="Enter Rate"
                value={formData.rate}
              />
            </InputGroup>
            <InputGroup>
              {" "}
              <InputLeftAddon>Discount</InputLeftAddon>
              <Input
                bg="white"
                onChange={(e) => {
                  handleInputChange(e);
                  change(e);
                }}
                name="discount"
                placeholder="Enter Discount"
                value={formData.discount}
              />
            </InputGroup>
            <InputGroup>
              {" "}
              <InputLeftAddon>Cgst</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="cgst"
                placeholder="Enter Cgst"
                value={formData.cgst}
              />
            </InputGroup>
            <InputGroup>
              {" "}
              <InputLeftAddon>Sgst</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="sgst"
                placeholder="Enter Sgst"
                value={formData.sgst}
              />
            </InputGroup>
          </SimpleGrid>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={4}
            mt={2}
          >
            <Button colorScheme="yellow" onClick={generateGst}>
              Generate Gst
            </Button>
            <Button colorScheme="green" onClick={(e) => handleEdit(e)}>
              Edit
            </Button>
          </Box>
        </ModalBody>

        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RoomBillEdittModal;
